module.exports = "/_next/static/images/6ab16a5cb1788dac3799f954a9edd82b-ppf-xs.png";